import { ApolloClient, HttpLink, InMemoryCache, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { datadogLogs } from "@datadog/browser-logs";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  // GraphQL Error
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      datadogLogs.logger.error("[APOLLO] GraphQL error", {
        message,
        location: JSON.stringify(locations),
        path: JSON.stringify(path),
      });
    });
  }

  // Network Error
  if (networkError) {
    datadogLogs.logger.error("[APOLLO] Network error", { networkError });
    throw new Error(`[APOLLO] Network error : ${JSON.stringify(networkError)}`);
  }
});

const authLink = setContext(() => {
  return {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-shopify-Storefront-Access-Token": import.meta.env.VITE_REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    },
  };
});

const httpLink = new HttpLink({ uri: import.meta.env.VITE_SHOPIFY_STOREFRONT_URI });

const client = new ApolloClient({
  uri: import.meta.env.VITE_SHOPIFY_STOREFRONT_URI,
  devtools: { enabled: false },
  cache: new InMemoryCache({
    typePolicies: {
      Collection: {
        keyFields: ["handle"],
      },
      Filter: {
        keyFields: ["values"],
      },
    },
  }),
  link: from([authLink, errorLink, httpLink]),
});

export default client;
